import airfreshner from "../../Images/air-freshner-ai.webp";
import { Link } from "react-router-dom";
import ScrollReveal from "../ScrollReveal/ScrollReveal";
import KineticText from "../KineticText";
import { useParallax } from "../../Hooks/useScrollReveal";

const ParallaxImage = ({ src, alt }) => {
  const ref = useParallax({ speed: 0.1 });
  return (
    <div className="overflow-hidden rounded-lg shadow-xl w-full h-full">
      <img ref={ref} alt={alt} src={src} className="w-full h-[120%] object-cover -mt-[10%]" />
    </div>
  );
};

const HomeSec3 = () => {
  return (
    <div className="flex flex-col xl:flex-row justify-center xl:h-[80vh] items-center w-[90vw] sm:w-[80vw] xl:w-[75vw] mx-auto py-10">
      <ScrollReveal className="w-[100%] sm:w-[80%] p-2 xl:w-[80%] md:p-10 lg:p-12 xl:p-16 my-auto" stagger={0.15} direction="up" distance={40}>
        <KineticText splitBy="char" className="text-3xl sm:text-4xl lg:text-5xl font-bold lg:w-[100%] mx-auto mb-10 text-secondary heading-font">
          Air Freshener
        </KineticText>
        <p className="lg:w-[100%] mx-auto text-xl md:text-2xl ">
          We produce a wide range of air fresheners designed to create pleasant
          environments. Our air fresheners are formulated with high-quality,
          long-lasting fragrances that enhance any space, whether it's at home,
          in the office, or in vehicles.
        </p>
        <div className="w-[100%] lg:w-[70%] mb-10 mt-6 md:hidden h-[250px]">
          <ParallaxImage
            alt="Air Freshener Manufacture"
            src="https://i.ibb.co.com/KzDYq3bZ/nextcare.avif"
          />
        </div>
        <p className="lg:w-[100%] mx-auto text-xl md:text-2xl mt-6">
          Our team works closely with you to create custom solutions that meet
          your unique needs, providing top-notch manufacturing services with
          attention to detail at every stage.
        </p>
        <div className="mt-10">
          <Link
            to="/air-freshner-manufacture"
            className="relative inline-block border border-secondary hover:text-white text-secondary lg:text-secondary bg-white font-bold py-4 px-6 sm:px-10 sm:py-4 rounded-lg overflow-hidden ease-in-out duration-200 border-[2px] group"
          >
            <span className="absolute inset-0 bg-secondary w-0 h-full transition-all duration-500 ease-out group-hover:w-full"></span>
            <span className="relative z-10">Want To Know More?</span>
          </Link>
        </div>
      </ScrollReveal>
      <ScrollReveal variant="clip" className="w-[90%] lg:w-[70%] mb-10 hidden md:block h-[400px] xl:h-[500px]">
        <ParallaxImage
          alt="Air Freshener Manufacture"
          src="https://i.ibb.co.com/KzDYq3bZ/nextcare.avif"
        />
      </ScrollReveal>
    </div>
  );
};

export default HomeSec3;
